'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GET_CONFIGURATION = exports.GET_CONFIGURATION = 'GET_CONFIGURATION';
var GET_ANALYTICS = exports.GET_ANALYTICS = 'GET_ANALYTICS';
var SET_ANALYTICS = exports.SET_ANALYTICS = 'SET_ANALYTICS';
var SET_SESSION = exports.SET_SESSION = 'SET_SESSION';
var GET_SESSION = exports.GET_SESSION = 'GET_SESSION';
var EXPIRE_SESSION = exports.EXPIRE_SESSION = 'EXPIRE_SESSION';
var SET_PARAMETERS = exports.SET_PARAMETERS = 'SET_PARAMETERS';
var GET_PARAMETERS = exports.GET_PARAMETERS = 'GET_PARAMETERS';
var GET_STOREFRONT_URL = exports.GET_STOREFRONT_URL = 'GET_STOREFRONT_URL';